export default angular
  .module("ModifySummaryTranslationCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifySummaryTranslationController", [
    "$scope",
    "summaryData",
    "$modalInstance",
    "Scripts",
    "System",
    function (
      $scope,
      summaryData,
      $modalInstance,
      Scripts,
      System,
    ) {
      $scope.textField = summaryData.SUMMARY_FIELD;

      const valueField = `S_${$scope.textField.toUpperCase()}`;
      const statusField = `TRANSLATION_STATUS_${$scope.textField.toUpperCase()}`;

      function compare(a, b) {
        if (a.NAME < b.NAME) return -1;
        if (a.NAME > b.NAME) return 1;
        return 0;
      }

      const changedLanguages = new Map();

      $scope.ok = function () {
        $scope.translations.forEach((entry) => {
          if (changedLanguages.get(entry.LANG)) {
            entry.SCRIPT_ID = summaryData.SCRIPT_ID;
            Scripts.updateScriptSummaryField($scope.textField, entry);
          }
        });
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };

      $scope.translations = [];
      $scope.openHistory = function (translationId, lang) {
        let entry = $scope.translations.find((entry) => translationId === entry.ID && lang === entry.LANG)
        entry.SHOWHISTORY = !entry.SHOWHISTORY;
      };
      System.loadLanguages((datalang) => {
        datalang.forEach((entry) => {
          Scripts.loadScriptSummaryByID(
            summaryData.SCRIPT_ID,
            entry.ABBREVIATION,
            (data) => {
              data.NAME = entry.NAME;
              data.ABBREVIATION = entry.ABBREVIATION;
              data.SHOWHISTORY = false;
              data.TEXT_VALUE = data[valueField];
              data.TRANSLATION_STATUS = data[statusField];
              Scripts.loadScriptMetadataHistoryByType(
                $scope.textField,
                data.ID,
                summaryData.SCRIPT_ID,
                (datahistory) => {
                  data.HISTORY = datahistory;
                  $scope.translations.push(data);
                  // sort alphabetically
                  $scope.translations = $scope.translations.sort(compare);
                },
              );
            },
          );
        });
      });

      $scope.changedField = function (language) {
        changedLanguages.set(language, true);
      };
    },
  ]);
